import { useState } from "react";

import { useTranslation } from "react-i18next";

import useLeadMutations from "../../../data/useLeadMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { ILead } from "../../../models/Lead";
import Card from "../../shared/Card/Card";

export default function LeadNotes({ lead, notesProp, title, hideCard = false }: { lead: ILead, notesProp: "officeNotes" | "driverNotes" | "yardNotes", title: string, hideCard?: boolean }) {
  const { t } = useTranslation("leads");
  const { updateNotes } = useLeadMutations(lead.id, "LeadNotes");
  const { saveHandlers } = useDefaultCRUDHandlers(title);
  const [notes, setNotes] = useState<string | null>(lead[notesProp] ?? null);

  const handleSaveNotes = () => {
    //Don't update if nothing changed
    if (notes === lead[notesProp]) return;

    // Only send the field that changed (true PATCH behavior)
    const updateData: { leadId: string; officeNotes?: string | null; driverNotes?: string | null; yardNotes?: string | null } = {
      leadId: lead.id,
    };

    if (notesProp === "officeNotes") {
      updateData.officeNotes = notes;
    } else if (notesProp === "driverNotes") {
      updateData.driverNotes = notes;
    } else if (notesProp === "yardNotes") {
      updateData.yardNotes = notes;
    }

    updateNotes.mutate(updateData, saveHandlers);
  };

  const body = (
    <div className="space-y-4">

      <textarea
        className="w-full border-gray-300"
        rows={5}
        defaultValue={lead[notesProp] ?? ""}
        onChange={(e) => setNotes(e.target.value)}
        onBlur={() => handleSaveNotes()}
      />

      <button
        className="rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
        onClick={() => handleSaveNotes()}
      >
        {t("Update")}
      </button>

    </div>
  );

  if (hideCard) {
    return <div className="p-4">{body}</div>;
  }

  return (
    <Card title={title} bodyClassName="p-4">
      {body}
    </Card>
  );
}